import { Link } from "react-router-dom";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { useCustomerContext } from "../../../../Context/CustomerContext";
import { useCustomerHasFsk8sPermissions } from "../../hooks";
import Fsk8sCloudPermissions from "./CloudPermissions";
import GetStartedStep from "./Step";

const GetStarted = () => {
  const { customer } = useCustomerContext();
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { customerHasFsk8sPermissions } = useCustomerHasFsk8sPermissions();

  return (
    <Stack spacing={2}>
      <Typography variant="h4">Get started</Typography>
      <Stack spacing={2} direction={isMdScreen ? "column" : "row"} display="flex" alignItems="stretch">
        <GetStartedStep
          caption="Step 1"
          title="Enable required permissions"
          description="Start your K8s journey by granting ‘FSK8s core’ for EKS clusters and ‘Kubernetes insights’ for GKE clusters. You only require one of these to install the agent"
          actions={<Fsk8sCloudPermissions />}
        />
        <Box display="flex" justifyContent="center" alignItems="center">
          {isMdScreen ? <ArrowDownwardIcon color="error" /> : <ArrowForwardIcon sx={{ color: "gray" }} />}
        </Box>
        <GetStartedStep
          caption="Step 2"
          title="Install agent on clusters"
          description="After permissions are in place we require you to install the agent so we can track cluster metrics. Clusters which have already have the agent installed via PerfectScale do not need another install"
          actions={
            <Button
              disabled={!customerHasFsk8sPermissions}
              component={Link}
              to={`/customers/${customer.id}/integrate/assets/kubernetes`}
              variant="outlined"
              sx={{ width: "fit-content" }}
            >
              Install agent
            </Button>
          }
        />
      </Stack>
    </Stack>
  );
};

export default GetStarted;
